import { useTranslation } from "react-i18next"

import { FileText } from "@/components/icons"
import { UserMessage } from "@/features/chat/components/user-message"
import { cn } from "@/lib/utils"

import { parseContinuedArtifactSeed } from "../utils/agent-artifacts-utils"

/**
 * A user turn in an agent thread. A turn started with "Continue working"
 * carries the artifact as an inline `<artifact …>` block (the model needs
 * it); the bubble shows the user's own words and a compact "Continuing from
 * <title> (vN)" chip instead of that raw XML.
 */
export function AgentUserMessage({ message }: { message: string }) {
  const { t } = useTranslation()
  const { text, seed } = parseContinuedArtifactSeed(message)
  if (!seed) return <UserMessage message={message} />
  const label = seed.version
    ? `${seed.title} (${t("agents.artifacts.version", { version: seed.version })})`
    : seed.title
  return (
    <UserMessage message={text}>
      <span
        data-testid="agent-continued-artifact"
        className={cn(
          "border-border bg-background/60 text-foreground inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-1 text-xs",
          text && "mt-2"
        )}
      >
        <FileText aria-hidden="true" className="size-3.5 shrink-0" />
        <span className="truncate">{t("agents.artifacts.continuing_from", { title: label })}</span>
      </span>
    </UserMessage>
  )
}
